module.exports = __webpack_public_path__ + "static/media/2.a04962e0.jpg";